module.exports = __webpack_public_path__ + "img/upData2.e59c18b1.png";